import { CampagneUserSelectors } from '@get/store/selectors';
import { SelectorModel } from '@get/utils';

// tslint:disable-next-line: variable-name
export const CampagneUserModel: SelectorModel = {
  name: 'campagneUsers',
  getSelector: CampagneUserSelectors.selectAllCampagneUsersDictionary,
  isReady: CampagneUserSelectors.selectIsReadyCampagneUser
};
